import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TicketSystemService } from '../services/ticket-system.service';

@Component({
  selector: 'app-identification-input',
  templateUrl: './identification-input.component.html',
  styleUrls: ['./identification-input.component.css']
})
export class IdentificationInputComponent implements OnInit {
  @ViewChild('unique_id') unique_id:ElementRef;
  constructor(private ticketService:TicketSystemService) {
  }

  ngAfterViewInit() {
    setTimeout(() => this.unique_id.nativeElement.focus());
  }

  ngOnInit() {
  }

  submit(data){
    this.ticketService.getAllTicket(data).subscribe(resp =>{
      console.log(resp)
    });
  }

}
